// extracted by mini-css-extract-plugin
export var con = "list-module--con--2M2PK";
export var title = "list-module--title--26BhC";
export var menu = "list-module--menu--2xPt7";
export var on = "list-module--on--2rPcG";
export var main = "list-module--main--nffeO";
export var video = "list-module--video--okF2H";
export var videoImg = "list-module--videoImg--1beod";
export var text = "list-module--text--3TUBg";